import React, { useState, useEffect } from 'react';
import { apiService } from '../../services';
import { utils } from '../../utils';

const Compliance: React.FC = () => {
  const [resumo, setResumo] = useState<any>(null);
  const [vencimentos, setVencimentos] = useState<any[]>([]);
  const [filtro, setFiltro] = useState('todos');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => { loadData(); }, [filtro]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadData = async () => {
    try {
      setIsLoading(true);
      const [resumoRes, vencRes] = await Promise.allSettled([
        apiService.getComplianceResumo(),
        apiService.getComplianceVencimentos(filtro !== 'todos' ? filtro : undefined)
      ]);

      if (resumoRes.status === 'fulfilled' && resumoRes.value.success) setResumo(resumoRes.value.data);
      if (vencRes.status === 'fulfilled' && vencRes.value.success) setVencimentos(vencRes.value.data || []);
    } catch (err: any) {
      utils.showNotification('Erro ao carregar dados de compliance', { type: 'error' });
    } finally { setIsLoading(false); }
  };

  const formatDate = (d: string) => d ? new Date(d).toLocaleDateString('pt-BR') : '-';

  const getStatusBadge = (dias: number) => {
    if (dias < 0) return <span className="status-badge status-danger">Vencido ha {Math.abs(dias)} dias</span>;
    if (dias === 0) return <span className="status-badge status-danger">Vence hoje</span>;
    if (dias <= 7) return <span className="status-badge status-danger">Vence em {dias} dias</span>;
    if (dias <= 30) return <span className="status-badge status-warning">Vence em {dias} dias</span>;
    return <span className="status-badge status-success">OK ({dias} dias)</span>;
  };

  if (isLoading) {
    return (
      <div className="page-container">
        <div className="page-header"><h1>Compliance - Documentos</h1></div>
        <div style={{ textAlign: 'center', padding: '100px 20px' }}>
          <div className="loading-spinner-large"></div>
          <p>Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header"><h1>Compliance - Controle de Documentos</h1></div>

      <div className="page-content">
        {/* Cards de resumo */}
        {resumo && (
          <div className="dashboard-grid" style={{ marginBottom: '20px' }}>
            <div className="stat-card" style={{ borderLeft: '4px solid #e74c3c' }}>
              <div className="stat-icon"><i className="fas fa-exclamation-circle" style={{ color: '#e74c3c' }}></i></div>
              <div className="stat-value" style={{ color: '#e74c3c' }}>{resumo.total_vencidos}</div>
              <div className="stat-label">Documentos Vencidos</div>
            </div>
            <div className="stat-card" style={{ borderLeft: '4px solid #f39c12' }}>
              <div className="stat-icon"><i className="fas fa-clock" style={{ color: '#f39c12' }}></i></div>
              <div className="stat-value" style={{ color: '#f39c12' }}>{resumo.total_vencendo_30_dias}</div>
              <div className="stat-label">Vencendo em 30 dias</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon"><i className="fas fa-truck"></i></div>
              <div className="stat-value">{parseInt(resumo.veiculos?.total_veiculos || 0)}</div>
              <div className="stat-label">Veiculos Ativos</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon"><i className="fas fa-id-card"></i></div>
              <div className="stat-value">{parseInt(resumo.motoristas?.total_motoristas || 0)}</div>
              <div className="stat-label">Motoristas Ativos</div>
            </div>
          </div>
        )}

        {/* Tabela de vencimentos */}
        <div className="card">
          <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2>Vencimentos de Documentos</h2>
            <div style={{ display: 'flex', gap: '8px' }}>
              {['todos', 'vencidos', 'vencendo'].map(f => (
                <button key={f} onClick={() => setFiltro(f)}
                  className={`btn ${filtro === f ? 'btn-primary' : 'btn-secondary'}`}
                  style={{ padding: '6px 14px', fontSize: '0.85rem' }}>
                  {f === 'todos' ? 'Todos' : f === 'vencidos' ? 'Vencidos' : 'Vencendo'}
                </button>
              ))}
            </div>
          </div>

          <div className="card-body">
            {vencimentos.length === 0 ? (
              <div className="empty-state">
                <i className="fas fa-check-circle empty-state-icon" style={{ color: '#04C64F' }}></i>
                <h3>{filtro === 'vencidos' ? 'Nenhum documento vencido!' : filtro === 'vencendo' ? 'Nenhum documento vencendo nos proximos 30 dias!' : 'Nenhum documento cadastrado com data de vencimento.'}</h3>
              </div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th>Documento</th>
                      <th>Identificacao</th>
                      <th>Descricao</th>
                      <th>Vencimento</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vencimentos.map((doc, i) => (
                      <tr key={i}>
                        <td><span className="status-badge status-info">{doc.entidade_tipo === 'veiculo' ? 'Veiculo' : 'Motorista'}</span></td>
                        <td><strong>{doc.documento}</strong></td>
                        <td>{doc.identificacao}</td>
                        <td style={{ color: '#7f8c8d' }}>{doc.descricao}</td>
                        <td>{formatDate(doc.data_vencimento)}</td>
                        <td>{getStatusBadge(doc.dias_restantes)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Compliance;
